import { Flex, Loader, Text } from "@aws-amplify/ui-react";
import React, { useMemo } from "react";

import { Team } from "../../game/Types/TeamTypes";
import { Player } from "../../game/Types/GameTypes_dep";
import { useAnswerResultsAnalytics } from "../../class";

export default function LeaderboardResult({
  team,
  players,
  i,
}: {
  team: Team;
  i: number;
  players: Player[];
}) {
  const { score } = useAnswerResultsAnalytics(team.gameData.answerResults);

  const teamPlayers = useMemo(() => {
    return players.filter((player) => team.id === player.groupId);
  }, [players, team]);

  const color = React.useMemo(() => {
    if (score < 50) return "var(--amplify-colors-red-60)";
    if (score < 80) return "var(--amplify-colors-orange-60)";
    return "var(--amplify-colors-green-80)";
  }, []);

  const average = useMemo(() => {
    // get all answerResults with isCorrect = true
    const correctAnswerResults = team.gameData.answerResults.filter(
      (answerResult) => answerResult.isCorrect
    );
    // get the total number of correct answers
    const totalCorrectAnswers = correctAnswerResults.length;
    // get the total number of answers
    const totalAnswers = team.gameData.answerResults.length;
    // return the average score
    if (totalAnswers === 0) {
      return 0;
    } else {
      return (totalCorrectAnswers / totalAnswers) * 100;
    }
  }, [team]);

  const correct = useMemo(() => {
    // get all answerResults with isCorrect = true
    const correctAnswerResults = team.gameData.answerResults.filter(
      (answerResult) => answerResult.isCorrect
    );
    // get the total number of correct answers
    const totalCorrectAnswers = correctAnswerResults.length;
    return totalCorrectAnswers;
  }, [team]);

  const total = useMemo(() => {
    const totalAnswers = team.gameData.answerResults.length;
    return totalAnswers;
  }, [team]);

  return teamPlayers.map((player) => (
    <Flex
      gap="large"
      columnGap={"large"}
      width={"100%"}
      grow={1}
      alignItems={"center"}
    >
      <Text
        flex={"auto"}
        fontSize={{ base: "smaller", medium: "medium" }}
        fontWeight={"semibold"}
        width={"3%"}
      >
        {i + 1}
      </Text>
      <Text
        id="raised-item"
        backgroundColor={color}
        color="white"
        borderRadius={"xxl"}
        textAlign={"center"}
        fontSize={{ base: "smaller", medium: "small" }}
        fontWeight={"semibold"}
        width="200px"
        isTruncated
      >
        {player.nickname}
      </Text>
      <Loader
        size="large"
        width={{ base: "60%", medium: "80%" }}
        variation="linear"
        emptyColor="var(--amplify-colors-red-60)"
        filledColor="var(--amplify-colors-green-60)"
        percentage={average}
        isDeterminate
        isPercentageTextHidden
        borderRadius={"small"}
      />
      <Text
        fontSize={{ base: "smaller", medium: "medium" }}
        textAlign={"center"}
        fontWeight={"semibold"}
        minWidth={"7%"}
      >
        {correct}/{total}
      </Text>
    </Flex>
  ));
}
